import React, { useContext, useEffect, useState } from "react";
import { t } from "i18next";
import { ChoiceGroup, PrimaryButton } from "@fluentui/react";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import userContext from "../../../context/users/UserContext";
import { USERTYPES } from "../../../constants/Constants";
import { useTranslation } from "react-i18next";
import themeContext from "../../../context/theme/ThemeContext";

const HeaderTemplateTab = (props) => {
  const { getAlterColor } = useContext(themeContext);
  console.log(
    "template->",
    props.id,
    props.defaultReport,
    props.masterStudyReportId,
    props.selectedHTab
  );

  const style = {
    main: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      padding: "10px",
      minWidth: "500px",
    },
    box: {
      display: "flex",
      color: getAlterColor("#DFDFDF","black"),
      width: "40px",
    },
    order: {
      fontSize: "16px",
      fontWeight: "400",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px 28px 10px 10px",
    },
    content: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      marginLeft: "5px",
      marginRight: "5px",
      padding: "0px 10px",
    },
    tabName: {
      alignItems: "center",
      display: "flex",
      margin: "0px 10px",
      padding: "0px",
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "42px",
    },
    selectedBtn: {
      height: "18px",
      fontWeight: "600",
      fontSize: "9px",
      lineHeight: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
      color: "#000000",
      backgroundColor: "#BEFF54",
      borderRadius: "8px",
      padding: "1px 5px",
      marginLeft: "20px",
    },
    checkBox: {
      // border:"1px solid white",
      justifyContent: "center",
      alignItems: "center",
      marginRight: "10px",
      display: "flex",
    },
    radiobtn: {
      display: "inline-flex",
      flexDirection: "row",
      flexWrap: "wrap",
      cursor: "pointer",
      width: "20px",
      height: "20px",
      backgroundColor: "#000000",
    },
    headerTemplateSetDefaultButton: {},
  };

  const handleChange = (id) => {
    // tempState = e.target.value;
    // props.setSelectedUTab(e.target.value)
    props.setSelectedHTab(id);
    props.setShowTemplateModal(true);
    props.setShowConfirmModal(true);
  };

  let tempState = props.selectedHTab;
  const [hovered, setHovered] = useState(false);
  const { roles } = useContext(userContext);
  const { t } = useTranslation();
  return (
    <div
      style={style.main}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={style.box}>
        <span style={style.order}>{props.orderNumber}</span>
      </div>
      <div style={style.content}>
        <div style={style.tabName}>
          <span>{"Template" + " " + props.id}</span>
          {(props.masterStudyReportId != -1
            ? props.masterStudyReportId == props.id
            : props.defaultReport) && (
            <>
              <span style={style.selectedBtn}>
                {roles[0] === USERTYPES.ADMIN
                  ? t("header-templates.system-default")
                  : t("header-templates.default")}
              </span>
            </>
          )}
          <PrimaryButton
            text={"SET DEFAULT"}
            style={{
              marginLeft: "20px",
              display: hovered ? "block" : "none",
              //borderRadius: "20px",
              height: "23px",
              fontWeight: "600",
              fontSize: "9px",
              lineHeight: "16px",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              borderRadius: "8px",
              padding: "1px 5px",
            }}
            onClick={() => {
              handleChange(props.id);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderTemplateTab;
